module.exports = __webpack_public_path__ + "static/assets/a5457ed71b875fd60cceb198cab3f0a6.png";